import { createFileRoute } from '@tanstack/react-router';
import { RequirePermission, UsersPage } from '@/modules/identity/public';

export const Route = createFileRoute('/_admin/usuarios')({
  component: () => (
    <RequirePermission anyOf={['usuarios.ver']}>
      <UsersPage />
    </RequirePermission>
  ),
});
